<template>
  <div>
    <v-row dense>
      <v-col cols="12" sm="6" md="7">
        <p class="mb-1">
          <span class="headline font-weight-bold text--primary">
            {{ nomeFornecedor }}
            <px-popover-fornecedor show-score
                                   :fornecedor-id="aprovacao.fornecedor.id"/>
          </span>
          <px-situacao-aprovacao :situacao="aprovacao.situacao"/>
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="5" class="text-right">
        <px-aprovacao-compra-controls show-as-buttons
                                      :aprovacao="aprovacao"
                                      @update="onUpdate"/>
      </v-col>
    </v-row>
    <p class="subtitle-card-detail mt-2">
      <v-icon>mdi-domain</v-icon>
      <px-fornecedor-documento :fornecedor="aprovacao.fornecedor"/>
    </p>
    <p class="subtitle-card-detail">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
            <span v-on="on">
              <v-icon>mdi-map-marker</v-icon>
              {{ endereco(aprovacao.fornecedor.endereco) }}
            </span>
        </template>
        <span>Endereço do fornecedor</span>
      </v-tooltip>
    </p>
    <p class="subtitle-card-detail">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
            <span v-on="on">
              <v-icon>mdi-account</v-icon>
              {{ aprovacao.usuario.nome }}
            </span>
        </template>
        <span>Solicitante</span>
      </v-tooltip>
    </p>
    <p class="subtitle-card-detail" v-if="aprovacao.dataAprovacao">
        <span>
          <v-icon>mdi-calendar</v-icon>
          Aprovada em {{ aprovacao.dataAprovacao | date }}
        </span>
    </p>
    <p class="subtitle-card-detail" v-if="aprovacao.codigoInternoFornecedor">
      <v-icon>mdi-alpha-c-box-outline</v-icon>
      <px-span-tooltip
        bottom
        :text="aprovacao.codigoInternoFornecedor"
        tooltip="Código interno do fornecedor"/>
    </p>
    <div class="text--primary">
      <v-row>
        <v-col cols="12" sm="6">
        <span class="caption font-weight-bold">
          Local de faturamento <v-icon small>mdi-map-marker-check</v-icon>
        </span>
          <v-row dense>
            <v-col cols="12">
              {{ aprovacao.comprador.pessoa.nome }} ({{ aprovacao.comprador.pessoa.cnpj | cnpj }})
              <div class="">
                {{ aprovacao.comprador.endereco | endereco }}
              </div>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="6">
        <span class="caption font-weight-bold">
          Local de entrega <v-icon small>mdi-map-marker</v-icon>
        </span>
          <v-row dense>
            <v-col cols="12">
              {{ aprovacao.locaisEntrega.nomeLocal }}
              <span v-if="aprovacao.locaisEntrega.codigoInterno">
                ({{ aprovacao.locaisEntrega.codigoInterno }})
              </span>
              <div class="">
                {{ aprovacao.locaisEntrega.endereco | endereco }}
              </div>
              <div class="mt-1" v-if="aprovacao.dataPrevisaoEntrega">
                <v-icon small left>mdi-calendar</v-icon>
                <span class="font-weight-bold">Previsão de entrega em </span>
                {{ aprovacao.dataPrevisaoEntrega | date }}
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" sm="3">
          <span class="caption font-weight-bold">Código</span>
          <div>
            {{ aprovacao.id }}
          </div>
        </v-col>
        <v-col cols="12" sm="3">
          <span class="caption font-weight-bold">Forma de pagamento</span>
          <div>
            <px-forma-pagamento :forma-pagamento="aprovacao.formaPagamento"
                                :prazo-pagamento="aprovacao.prazoPagamento"/>
          </div>
        </v-col>
        <v-col cols="12" sm="3">
          <span class="caption font-weight-bold">Modo de pagamento</span>
          <div>
            {{ modoPagamento | naoInformado }}
          </div>
        </v-col>
        <v-col cols="12" sm="3">
          <span class="caption font-weight-bold">Observações internas</span>
          <div>
            <px-show-large-text :large-text="aprovacao.observacao"/>
          </div>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" sm="3">
          <span class="caption font-weight-bold">Tipo de frete</span>
          <div>
            {{ aprovacao.frete.tipoFrete }}
          </div>
        </v-col>
        <v-col cols="12" sm="3">
          <span class="caption font-weight-bold">Mensagem para o fornecedor</span>
          <div>
            <px-show-large-text :large-text="aprovacao.mensagem"/>
          </div>
        </v-col>
        <v-col cols="12" sm="3">
          <span class="caption font-weight-bold">Observação do frete</span>
          <div>
            <px-show-large-text :large-text="aprovacao.frete.observacaoFrete"/>
          </div>
        </v-col>
        <v-col cols="12" sm="3">
          <span class="caption font-weight-bold">Finalidade da Compra</span>
          <div v-if="aprovacao.finalidadeCompra">
            <px-finalidade-compra-value :finalidade-compra="aprovacao.finalidadeCompra"/>
          </div>
          <div v-else>
            Não Informado
          </div>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" sm="3">
          <span class="caption font-weight-bold">Data de Faturamento</span>
          <div v-if="aprovacao.dataFaturamento">
            {{ aprovacao.dataFaturamento | date }}
          </div>
          <div v-else>
            Não Informado
          </div>
        </v-col>
        <v-col cols="12" sm="3" v-if="aprovacao.dataNecessidadeEntregaSolicitacao">
          <span class="caption font-weight-bold">Data de entrega solicitante</span>
          <div>
            {{ aprovacao.dataNecessidadeEntregaSolicitacao | date }}
          </div>
        </v-col>
        <v-col cols="12" sm="3" v-if="hasTaxaFinanceira">
          <span class="caption font-weight-bold">Percentual taxa financeira</span>
          <div v-if="aprovacao.percentualTaxa">
              {{ percentualTaxa | number('0.00') }}%
            </div>
            <div v-else>
              0,00%
            </div>
        </v-col>
        <v-col cols="12" sm="3" v-if="aprovacao.saving > 0">
          <span class="caption font-weight-bold">Desconto</span>
          <div>
            {{ aprovacao.valorMoedaConvertido.saving |
             currency(simboloMoeda, casaDecimal, configuracaoFormatacaoMoeda) }}
          </div>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" sm="3" v-if="aprovacao.projeto">
          <span class="caption font-weight-bold">Projeto</span>
          <div>
            {{ projeto | truncate(40) }}
          </div>
        </v-col>
        <v-col cols="12" sm="3" v-if="aprovacao.centroCusto">
          <span class="caption font-weight-bold">Centro de custo</span>
          <div>
            {{ centroCusto | truncate(40) }}
          </div>
        </v-col>
        <v-col cols="12" sm="3" v-if="aprovacao.tipoNotaEntrada">
          <span class="caption font-weight-bold">Tipo de nota de entrada</span>
          <div>
            <px-span-tooltip top
                             :text="notaEntrada"
                             :tooltip="aprovacao.tipoNotaEntrada.descricao"/>
          </div>
        </v-col>
        <v-col cols="12" sm="3" v-if="aprovacao.cfop">
          <span class="caption font-weight-bold">CFOP da compra</span>
          <div>
            <px-span-tooltip top
                             :text="cfop"
                             :tooltip="`${aprovacao.cfop.codigo} - ${aprovacao.cfop.descricao}`"/>
          </div>
        </v-col>
      </v-row>
      <v-row v-if="isCancelado">
        <v-col cols="12">
          <span class="caption font-weight-bold">Motivo do cancelamento</span>
          <div>
            Acesse o detalhe do item para saber o motivo da recusa/cancelamento.
          </div>
        </v-col>
      </v-row>
      <px-campos-integracao v-if="cadastrosAdicionais"
                                type="compra-view"
                                :form-data="cadastrosAdicionais"/>
      <v-row dense>
        <v-col cols="12" sm="3" v-if="aprovacao.arquivos && aprovacao.arquivos.length">
          <span class="caption font-weight-bold">Anexos</span>
          <div>
            <px-anexo-chip :files="aprovacao.arquivos"
                           download-base-path="files/download-comprador"/>
          </div>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" sm="4">
          <template v-if="isMoedaEstrangeira">
            <v-row dense no-gutters class="body-1">
              <v-col cols="6">
                Produtos:
              </v-col>
              <v-col cols="6" class="text-right">
                <px-moeda-chip :moeda="moeda"/>
                {{
                  aprovacao.totalProdutos |
                    currency(simboloMoeda, casaDecimal, configuracaoFormatacaoMoeda)
                }}
              </v-col>
              <v-col cols="6">
                Frete:
              </v-col>
              <v-col cols="6" class="text-right">
                {{
                  aprovacao.frete.totalTransporte |
                    currency(simboloMoeda, 2, configuracaoFormatacaoMoeda)
                }}
              </v-col>
              <v-col cols="6" class="font-weight-bold">
                Total:
              </v-col>
              <v-col cols="6" class="text-right">
                  <span class="text--primary--color font-weight-bold">
                    {{
                      aprovacao.total |
                        currency(simboloMoeda, casaDecimal, configuracaoFormatacaoMoeda)
                    }}
                  </span>
              </v-col>
              <v-col cols="6" class="font-weight-bold" v-if="hasTaxaFinanceira">
                Total com taxa financeira:
              </v-col>
              <v-col cols="6" class="text-right" v-if="hasTaxaFinanceira">
                  <span class="text--primary--color font-weight-bold">
                    {{ totalTaxaFinanceira
                      | currency(simboloMoeda, casaDecimal, configuracaoFormatacaoMoeda) }}
                  </span>
              </v-col>
              <template v-if="isMoedaEstrangeira && aprovacao.saving">
                <v-col cols="6" class="font-weight-bold">
                  Saving:
                </v-col>
                <v-col cols="6" class="text-right">
                      <span class="text--success--color font-weight-bold">
                        {{
                          aprovacao.saving |
                            currency(simboloMoeda, casaDecimal, configuracaoFormatacaoMoeda)
                        }}
                      </span>
                </v-col>
              </template>
            </v-row>
          </template>
        </v-col>
        <v-col cols="12" sm="4"></v-col>
        <v-col cols="12" sm="4">
          <v-row dense no-gutters class="body-1">
            <v-col cols="6">
              Produtos:
            </v-col>
            <v-col cols="6" class="text-right">
              {{ aprovacao.valorMoedaConvertido.totalProdutos | currency('R$', casaDecimal) }}
            </v-col>
            <v-col cols="6">
              Frete:
            </v-col>
            <v-col cols="6" class="text-right">
              {{ aprovacao.frete.totalTransporteConvertido | currency }}
            </v-col>
            <v-col cols="6" class="font-weight-bold">
              Total:
            </v-col>
            <v-col cols="6" class="text-right">
                  <span class="text--primary--color font-weight-bold">
                    {{ aprovacao.valorMoedaConvertido.total | currency('R$', casaDecimal) }}
                  </span>
            </v-col>
            <v-col cols="6" class="font-weight-bold" v-if="hasTaxaFinanceira">
              Total com taxa financeira:
            </v-col>
            <v-col cols="6" class="text-right" v-if="hasTaxaFinanceira">
                  <span class="text--primary--color font-weight-bold">
                    {{ totalTaxaFinanceiraConvertido | currency('R$', casaDecimal) }}
                  </span>
            </v-col>
            <template v-if="aprovacao.saving">
              <v-col cols="6" class="font-weight-bold">
                Saving:
              </v-col>
              <v-col cols="6" class="text-right">
                      <span class="text--success--color font-weight-bold">
                        {{ aprovacao.valorMoedaConvertido.saving |
                         currency('R$', casaDecimal) }}
                      </span>
              </v-col>
            </template>
          </v-row>
        </v-col>
      </v-row>

    </div>
    <px-confirm-dialog ref="confirm"/>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { descWithCodigoInterno } from '@/utils/object-utils';
import { SituacaoAprovacao } from 'px-business-components';
import AprovacaoCompraControls
  from '@/modules/aprovacao-compra/components/AprovacaoCompraControls.vue';
import { computeEndereco } from '@/utils/endereco-utils';
import { cadastrosAdicionaisToMap } from '@/utils/campos-integracao-utils';
import {
  calcularTotaisTaxaFinanceira,
  calcularTotaisTaxaFinanceiraConvertido,
} from '@/modules/compra/cadastro/calculo-compra.service';
import moedaMixin from '@/mixins/moeda-mixin';
import { CasaDecimalUtils } from 'px-components';

export default {
  mixins: [moedaMixin],
  props: {
    aprovacao: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters('entidade', ['hasTaxaFinanceira']),
    moeda() {
      return this.aprovacao.moeda;
    },
    modoPagamento() {
      return this.aprovacao.modoPagamento ? this.aprovacao.modoPagamento.descricao : null;
    },
    cfop() {
      return `${this.aprovacao.cfop.codigo} - ${Vue.filter('truncate')(this.aprovacao.cfop.descricao, 20)}`;
    },
    notaEntrada() {
      return Vue.filter('truncate')(this.aprovacao.tipoNotaEntrada.descricao, 20);
    },
    projeto() {
      return descWithCodigoInterno(this.aprovacao.projeto);
    },
    centroCusto() {
      return descWithCodigoInterno(this.aprovacao.centroCusto);
    },
    endereco() {
      return endereco => computeEndereco(endereco);
    },
    nomeFornecedor() {
      return this.aprovacao.nomeInternoFornecedor || this.aprovacao.fornecedor.pessoa.nome;
    },
    cadastrosAdicionais() {
      if (!this.aprovacao.cadastrosAdicionais || !this.aprovacao.cadastrosAdicionais.length) {
        return null;
      }
      return cadastrosAdicionaisToMap(this.aprovacao.cadastrosAdicionais);
    },
    isCancelado() {
      return SituacaoAprovacao.keys.RECUSADO.key === this.aprovacao.situacao;
    },
    percentualTaxa() {
      return this.aprovacao.percentualTaxa * 100;
    },
    casaDecimal() {
      const mappedProdutos = this.aprovacao.produtos.map(produto => produto.produto);
      return CasaDecimalUtils.getCasaDecimal(mappedProdutos);
    },
    totalTaxaFinanceira() {
      return calcularTotaisTaxaFinanceira(this.aprovacao, this.aprovacao.produtos);
    },
    totalTaxaFinanceiraConvertido() {
      return calcularTotaisTaxaFinanceiraConvertido(this.aprovacao, this.aprovacao.produtos);
    },
  },
  methods: {
    onUpdate(aprovacaoAtualizada) {
      this.$emit('update', aprovacaoAtualizada);
    },
  },
  components: {
    pxAprovacaoCompraControls: AprovacaoCompraControls,
  },
};
</script>
